module.exports = __webpack_public_path__ + "static/media/glass-martini.838fef20.svg";